import React, { useEffect, useState } from 'react'
import { useLocation } from 'react-router';
import axiosBackend from '../axios/axios';

export default function ShowTermsPage() {
    const [showData, setShowData] = useState({});
    const [loaded, setLoaded] = useState(false);
    const location = useLocation();
    const searchParams = new URLSearchParams(location.search);
    const showID = searchParams.has("showId")
        ? searchParams.get("showId")
        : false;


    async function getShowDetails() {
        try {
            const res = await axiosBackend.get(`/api/Show/GetShowEntrybyId?id=${showID}`);
            if (res.status == 200) {
                if (res.data.responseCode == 200) {
                    setShowData(res.data.result);
                    setLoaded(true);
                }
            }

        } catch (error) {
            console.debug('error', error);
        }
    }

    useEffect(() => {
        getShowDetails();
    }, [])


    return (
        loaded &&
        <div className='row' >
            <div className='col-12' dangerouslySetInnerHTML={{__html:showData?.termsAndConditions}} />
        </div>
    )
}
